/**
 * This code was  originally copied from the lexical playground source code on github
 * And so it doesn't follow our code style
 * https://github.com/facebook/lexical/tree/main/packages/lexical-playground
 *
 */

import type {
    DOMConversionMap,
    DOMConversionOutput,
    DOMExportOutput,
    EditorConfig,
    LexicalEditor,
    LexicalNode,
    RangeSelection,
    SerializedElementNode,
} from "lexical";
import { $createParagraphNode, $createTextNode, $isElementNode, ElementNode, TextNode } from "lexical";

import { $isRepeatableContainerNode } from "./RepeatableContainerNode";
import { $isRepeatableContentNode } from "./RepeatableContentNode";

type SerializedRepeatableTitleNode = SerializedElementNode;

export function convertSummaryElement(domNode: HTMLElement): DOMConversionOutput | null {
    const node = $createRepeatableTitleNode();
    return {
        node,
    };
}

/**
 * RepeatableTitleNode is a lexical mandatory element of any type of ContainerNode
 */
export class RepeatableTitleNode extends ElementNode {
    static getType(): string {
        return "repeatable-title";
    }

    static clone(node: RepeatableTitleNode): RepeatableTitleNode {
        return new RepeatableTitleNode(node.__key);
    }

    createDOM(config: EditorConfig, editor: LexicalEditor): HTMLElement {
        const dom = document.createElement("summary");
        dom.classList.add("Repeatable__title");
        return dom;
    }

    updateDOM(prevNode: RepeatableTitleNode, dom: HTMLElement): boolean {
        return false;
    }

    static importDOM(): DOMConversionMap | null {
        return {
            summary: (domNode: HTMLElement) => {
                return {
                    conversion: convertSummaryElement,
                    priority: 1,
                };
            },
        };
    }

    static importJSON(serializedNode: SerializedRepeatableTitleNode): RepeatableTitleNode {
        return $createRepeatableTitleNode();
    }

    exportDOM(): DOMExportOutput {
        const element = document.createElement("summary");
        return { element };
    }

    exportJSON(): SerializedRepeatableTitleNode {
        return {
            ...super.exportJSON(),
            type: "repeatable-title",
            version: 1,
        };
    }

    collapseAtStart(_selection: RangeSelection): boolean {
        this.getParentOrThrow().insertBefore(this);
        return true;
    }

    insertNewAfter(_: RangeSelection, restoreSelection = true): ElementNode {
        const containerNode = this.getParentOrThrow();

        if (!$isRepeatableContainerNode(containerNode)) {
            throw new Error("RepeatableTitleNode expects to be child of RepeatableContainerNode");
        }

        if (containerNode.getOpen()) {
            const contentNode = this.getNextSibling();
            if (!$isRepeatableContentNode(contentNode)) {
                throw new Error("RepeatableTitleNode expects to have RepeatableContentNode sibling");
            }

            const firstChild = contentNode.getFirstChild();
            if ($isElementNode(firstChild)) {
                return firstChild;
            } else {
                const paragraph = $createParagraphNode();
                contentNode.append(paragraph);
                return paragraph;
            }
        } else {
            const paragraph = $createParagraphNode();
            containerNode.insertAfter(paragraph, restoreSelection);
            return paragraph;
        }
    }
}

export function $createRepeatableTitleNode(): RepeatableTitleNode {
    return new RepeatableTitleNode();
}

export function $isRepeatableTitleNode(node: LexicalNode | null | undefined): node is RepeatableTitleNode {
    return node instanceof RepeatableTitleNode;
}
